import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FetchSequences } from '../../../actions/sequence';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import _findKey from 'lodash/findKey';
import Fuse from 'fuse.js';
import _forEach from 'lodash/forEach';
import _orderBy from 'lodash/orderBy';
import _unionBy from 'lodash/unionBy';
import _findIndex from 'lodash/findIndex';
import { CYOA_NETWORK_IDS } from '../../../config'
import { getCyoaName } from '../../../helpers/cyoaHelper';

const queryString = require('query-string');
const parsed = queryString.parse(window.location.search);

class UpdatesPanel extends PureComponent{

  constructor(props){

    super(props);

    this.state = {
      activeCity:'',

      travelStyles:{},
      sequenceSliders:{},
      selectedSlider:{}, //selected slider options
      selectedCard:"", //active style card state
      travelStyleKey:0,

      daySliderMin:0,
      daySliderMax:10,
      daySliderValue:0,
      daySliderText:0,

      stopSliderMin:0,
      stopSliderMax:10,
      stopSliderValue:0,
      stopSliderText:0,

      ready:{
        city:false
      },
      searchIsOpen:false,
      cities:[],
      originalSearchList:[],
      searchList:[],
      searchInputValue:"",
      searchDropdownNumber:-1,
      searchReady:false
    }

    this.fuse = null;

    this.onStyleClicked = this.onStyleClicked.bind(this);
    this.onCloseClicked = this.onCloseClicked.bind(this);
    this.refreshClicked = this.refreshClicked.bind(this);
    this.searchbarClicked = this.searchbarClicked.bind(this);
    // this.documentClickHandler = this.documentClickHandler.bind(this);
    this.documentKeydownHandler = this.documentKeydownHandler.bind(this);
    this.cityClicked = this.cityClicked.bind(this);
  }

  documentKeydownHandler(e){

    const { searchIsOpen, searchDropdownNumber } = this.state;
    const searchInput = document.querySelectorAll('.builder-search-wrapper .builder-search-results ul li');
    const searchActive = document.querySelector('.builder-search-wrapper .builder-search-results ul li[data-index="'+searchDropdownNumber+'"]');


    if(searchIsOpen){

      //Increment/Decrement cursor position
      if(e.key === 'ArrowDown' && searchDropdownNumber < searchInput.length - 1){
        this.setState({searchDropdownNumber:searchDropdownNumber + 1});
      }
      else if(e.key === 'ArrowUp' && searchDropdownNumber > 0){
        this.setState({searchDropdownNumber:searchDropdownNumber - 1});
      }
      else if(e.key === 'Enter' && searchActive !== null){
        this.cityClicked(searchActive.dataset.name, searchActive.dataset.name);
      }
    }
  }

  searchbarClicked(){

      this.setState({searchIsOpen: !this.state.searchIsOpen});

      window.scrollTo({
        top: ReactDOM.findDOMNode(this).getBoundingClientRect().top,
        left: 0,
        behavior: 'smooth'
      });

  }

  componentDidMount(){

    // document.body.addEventListener('click', this.documentClickHandler);

    //Re-set city filter (back from preview page on browser)
    if(parsed.city !== undefined){
      this.setState({activeCity:parsed.city});
    }
  }

  componentWillUnmount(){
    // document.body.removeEventListener('click', this.documentClickHandler);
    this.fuse = null;
  }


  componentDidUpdate(prevProps, prevState){

    const { info, sequences, citiesData } = this.props;
    const { searchDropdownNumber, searchInputValue, activeCity } = this.state;
    const parsed = queryString.parse(window.location.search);

    if(info !== prevProps.info){
      this.setState({travelStyles:info.uri_params_attributes.trip_style});
    }

    if(sequences !== prevProps.sequences){
      this.setState({sequenceSliders:sequences.header.slider}, () => {

        //Re-set values if page refreshed
       if(parsed.city !== undefined && Object.keys(this.state.travelStyles).length > 0){

          //find index of stops query parameter from selectedSlider, pass index to handleStopChange
          const STYLE_KEY = _findKey(this.state.travelStyles,['name', this.state.travelStyles[1].name]);
          const SELECTED_SLIDER = this.state.sequenceSliders[STYLE_KEY];
          const MAPPED_SELECTED_SLIDER = this.sliderValues(SELECTED_SLIDER);
          const index = _findIndex(MAPPED_SELECTED_SLIDER, (i) => i.stop ===  parsed.stops);

          this.setState({
            activeCity:parsed.city,
            travelStyleKey:STYLE_KEY,
            stopSliderMax:MAPPED_SELECTED_SLIDER.length-1,
            daySliderMax:MAPPED_SELECTED_SLIDER.length-1,
            selectedSlider:MAPPED_SELECTED_SLIDER,
            stopSliderValue: index,
            stopSliderText: getCyoaName() !== "usa" ? parseInt(MAPPED_SELECTED_SLIDER[index].stop, 10) : 0,
            daySliderValue: getCyoaName() !== "usa" ? parseInt(MAPPED_SELECTED_SLIDER[index].days, 10) : 0,
            daySliderText: getCyoaName() !== "usa" ? parseInt(MAPPED_SELECTED_SLIDER[index].days, 10) : 0
          });

        }

      });
    }

    if(searchDropdownNumber !== prevState.searchDropdownNumber){
      const searchInputContainer = document.querySelector('.builder-search-wrapper .builder-search-results');
      const searchInput = document.querySelectorAll('.builder-search-wrapper .builder-search-results ul li');

      for(let i = 0; i < searchInput.length; i++){
        searchInput[i].classList.remove('hover');
      }

      if(searchInput[searchDropdownNumber].dataset.name !== undefined){

        //hover state
        searchInput[searchDropdownNumber].classList.add('hover');

        //scroll container
        searchInputContainer.scrollTop = searchInput[searchDropdownNumber].offsetTop;

      }

    }

    if(citiesData !== prevProps.citiesData){

      //Save all cities and popular cities
      let citiesArr = [];
      let popularArr = [];

      const citiesSorted =  _orderBy(citiesData, ['city', 'asc']);
      const popularSorted = _orderBy(citiesData, ['popularity', 'asc']);

      popularArr.push({name:'Top destinations', type:'title'});
      citiesArr.push({name:'All destinations', type:'title'});

      _forEach(citiesSorted, (o) => {citiesArr.push({name:o.city, type:"city"})});
      _forEach(popularSorted, (o, i) => { if(i < 10) popularArr.push({name:o.city, type:"popular"})});

      const originalSearchList = _unionBy(popularArr, citiesArr);
      const searchList = citiesSorted.map(o => { return {name:o.city, type:"city"} });
   

      this.setState({originalSearchList:(window.location.pathname === CYOA_NETWORK_IDS["usa"].slug ? searchList : originalSearchList ), searchList: searchList});


      //initialise fuse fuzzy search
      this.fuse = new Fuse(originalSearchList, {
        shouldSort: true,
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        threshold: 0.3,
        location: 0,
        distance: 10,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        keys: ["name"]
     });

     //Cities ready
     this.setState(prevState => ({ ready: {...prevState.ready, city: true} }))

    }


    if(searchInputValue !== prevState.searchInputValue){

      if(searchInputValue.length > 0 && activeCity !== '') {
        this.onCloseClicked();
      }

    }

  }

  searchHandleChange(e){
    this.setState({searchInputValue:e.target.value});
    this.search(e.target.value);
  }

  renderSearchResultItems(arr, pattern){

    const { originalSearchList } = this.state;

    let searchResultOriginal = [];
    let searchResultItems = [];
    let count = -1;

    //create modify search list
    for (let i = 0; i < arr.length; i++){
      if(arr[i].type !== 'popular' && arr[i].type !== 'title'){
        count++;
        searchResultItems.push(
          <li key={ `${arr[i].name}${Math.random()}` } data-index={count} data-test="test" data-name={arr[i].name} className={`${arr[i].type}`} onClick={ (e)=>{ this.cityClicked(arr[i].name, arr[i].name) } }>
            <span>{arr[i].name}</span>
          </li>
        )
      }
    }

    for (let j = 0; j < originalSearchList.length; j++){
      searchResultOriginal.push(
        <li key={ `${originalSearchList[j].name}${Math.random()}` } data-index={j} data-name={originalSearchList[j].name} className={`${originalSearchList[j].type}`} onClick={ (e)=>{ this.cityClicked(originalSearchList[j].name, originalSearchList[j].name) } }>
          <span>{originalSearchList[j].name}</span>
        </li>
      )
    }

    return (pattern === "") ? searchResultOriginal : searchResultItems;

  }

  search(pattern){

    const { ready, originalSearchList } = this.state;

    if(ready.city){
      const _searchPattern = (pattern === "") ? originalSearchList : this.fuse.search(pattern);
      return <ul id="search-result-list">{this.renderSearchResultItems(_searchPattern, pattern)}</ul>
    }else{
      return <p className="loading-text">Loading...</p>
    }
  }

  renderSearchPlaceholder(){

    const { activeCity, stopSliderText, daySliderText } = this.state;

    if(activeCity === "") return 'Choose a popular destination and itinerary';
    if(activeCity !== "" && stopSliderText !== 0 && daySliderText !== 0) return `${activeCity} -  ${daySliderText} days and ${stopSliderText} stops`;
    if(activeCity !== "") return activeCity;

  }

  cityClicked(city){
    const { travelStyles } = this.state;
    this.setState({searchInputValue:""});
    this.onStyleClicked(travelStyles[1].name, city);
  }

  onStyleClicked(travelStyle, city){


    const { travelStyles, sequenceSliders} = this.state;
    const STYLE_KEY = _findKey(travelStyles,['name', travelStyle]);
    const SELECTED_SLIDER = sequenceSliders[STYLE_KEY];
    const MAPPED_SELECTED_SLIDER = this.sliderValues(SELECTED_SLIDER);

    //set max days, max stops and selected style values
    this.setState({
      travelStyleKey:STYLE_KEY,
      selectedCard:travelStyle,
      stopSliderMax:MAPPED_SELECTED_SLIDER.length-1,
      daySliderMax:MAPPED_SELECTED_SLIDER.length-1,
      selectedSlider:MAPPED_SELECTED_SLIDER,
      daySliderValue:0,
      daySliderText:0,
      stopSliderValue:0,
      stopSliderText:0,
      activeCity:city
    }, () => {

      if(getCyoaName() === "usa"){
        this.refreshClicked();
      }

    });


  }

  // handleDayChange = value => {
  //
  //   if(Object.keys(this.state.selectedSlider).length > 0){
  //     try{
  //       this.setState({
  //         daySliderValue: value,
  //         daySliderText: parseInt(this.state.selectedSlider[value].days, 10),
  //         stopSliderValue: parseInt(this.state.selectedSlider[value].stop, 10),
  //         stopSliderText: parseInt(this.state.selectedSlider[value].stop, 10)
  //       });
  //     }
  //     catch(e){}
  //   }
  // }

  handleStopChange = value => {

    if(Object.keys(this.state.selectedSlider).length > 0){
      try{
        this.setState({
          stopSliderValue: value,
          stopSliderText: parseInt(this.state.selectedSlider[value].stop, 10),
          daySliderValue: parseInt(this.state.selectedSlider[value].days, 10),
          daySliderText: parseInt(this.state.selectedSlider[value].days, 10)
        });
      }
      catch(e){}
    }

  }


  sliderValues(str){

    const newStr = str.split(",");
    let sliderValuesArr = [];

    for(let i=0; i < newStr.length; i++){
      sliderValuesArr.push({
        stop: newStr[i].slice(0, newStr[i].indexOf(":")),
        days: newStr[i].slice(newStr[i].indexOf(":")+1, newStr[i].length)
      })
    }

    return sliderValuesArr;
  }


  refreshClicked(){

    const { travelStyleKey, activeCity, daySliderText, stopSliderText } = this.state;
    const { currencyInfo, FetchSequences, toggleCheck, cyoaId } = this.props;

    const bundle = (toggleCheck) ? 1 : 0;
    const destination = (cyoaId === CYOA_NETWORK_IDS["usa"].id) ? CYOA_NETWORK_IDS["usa"].name : CYOA_NETWORK_IDS["europe"].name;


    if(getCyoaName() !== "usa"){
      
      if(travelStyleKey !== 0 && activeCity !== "" && daySliderText !== 0 && stopSliderText !== 0){
      console.log("TCL: refreshClicked -> travelStyleKey", travelStyleKey)
      
        const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?travelstyle=cyoa&style=" + travelStyleKey + "&optionals=2&city=" + activeCity + "&currency=" + currencyInfo.iso_currency_code + "&stops=" + stopSliderText + "&bundle=" + bundle + "&destination=" + destination;

        if (window.history.pushState) {
            window.history.pushState({path:newurl},'',newurl);
        }

        FetchSequences(
          travelStyleKey, 
          2, 
          activeCity, 
          currencyInfo.iso_currency_code, 
          stopSliderText, 
          null, 
          bundle,
          null,
          cyoaId
        );


        this.setState({searchIsOpen:false});
      }
    }else{

      const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?travelstyle=cyoa&style=" + travelStyleKey + "&optionals=2&city=" + activeCity + "&currency=" + currencyInfo.iso_currency_code + "&stops=" + stopSliderText + "&bundle=" + bundle + "&destination=" + destination;
      if (window.history.pushState) window.history.pushState({path:newurl},'',newurl);
      
      FetchSequences(
        1, 
        2, 
        activeCity, 
        currencyInfo.iso_currency_code, 
        8, 
        null, 
        bundle,
        null,
        cyoaId
      );

      this.setState({searchIsOpen:false});


    }


  }

  onCloseClicked(){
    this.setState({
      activeCity:"",
      daySliderMin:0,
      daySliderMax:10,
      daySliderValue:0,
      daySliderText:0,
      stopSliderMin:0,
      stopSliderMax:10,
      stopSliderValue:0,
      stopSliderText:0,
      searchInputValue:""
    });
  }

  render(){

    const {
      activeCity, daySliderText, stopSliderMin, stopSliderMax, stopSliderValue, stopSliderText, searchInputValue, searchIsOpen
     } = this.state;


    return (
      <div className="row">
        <div className="columns small-12 medium-10 large-6 medium-offset-1 large-offset-3 end">
          <div className="builder-search-wrapper">
            <div className="builder-search-bar" onClick={this.searchbarClicked}>

              <svg xmlns="http://www.w3.org/2000/svg" className="city-svg" width="60.3379" height="76.0089" viewBox="0 0 60.3379 76.0089">
              <g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M30.1689,43.39A16.5073,16.5073,0,1,1,46.6758,26.8829,16.5263,16.5263,0,0,1,30.1689,43.39Zm0-29.0146A12.5073,12.5073,0,1,0,42.6758,26.8829,12.522,12.522,0,0,0,30.1689,14.3755Z"/><path d="M30.1689,36.1363a9.2534,9.2534,0,1,1,9.2529-9.2534A9.2641,9.2641,0,0,1,30.1689,36.1363Zm0-14.5068a5.2534,5.2534,0,1,0,5.2529,5.2534A5.2592,5.2592,0,0,0,30.1689,21.6295Z"/><path d="M40.6738,65.1212a2,2,0,0,1-1.6182-3.1729c3.7217-5.14,13.7432-19.4116,15.3965-23.67a24.1429,24.1429,0,0,0,1.8857-8.5c0-7.624-2.7061-14.4121-7.6182-19.1133A24.7721,24.7721,0,0,0,30.2568,4.0279q-.0879.0044-.1758,0a24.7635,24.7635,0,0,0-18.4629,6.6367C6.7061,15.3658,4,22.1539,4,29.7779a22.3385,22.3385,0,0,0,1.3877,7.1436C6.95,41.4517,18.2266,56.483,22.4395,61.8922a2,2,0,0,1-3.1562,2.458C17.6914,62.3057,3.6689,44.2042,1.6064,38.2266A26.2575,26.2575,0,0,1,0,29.7779C0,21.0518,3.1445,13.2374,8.8535,7.775A28.733,28.733,0,0,1,30.1689.0279,28.76,28.76,0,0,1,51.4844,7.775c5.709,5.4624,8.8535,13.2769,8.8535,22.0029a28.018,28.018,0,0,1-2.1572,9.9473C56.0029,45.3345,42.8545,63.5225,42.2959,64.294A1.9972,1.9972,0,0,1,40.6738,65.1212Z"/><path d="M30.1689,76.0089a1.9935,1.9935,0,0,1-1.4141-.5859l-4.4521-4.4521a2,2,0,0,1,2.8281-2.8281L30.1689,71.18l3.0381-3.0376a2,2,0,0,1,2.8281,2.8281L31.583,75.4229A1.9935,1.9935,0,0,1,30.1689,76.0089Z"/></g></g></svg>


              <input type="search" id="search-input" value={searchInputValue} placeholder={this.renderSearchPlaceholder()} onChange={ e => this.searchHandleChange(e) } onKeyDown={e => this.documentKeydownHandler(e)} className={`${activeCity !== "" ? 'active' : ''}`} autoComplete="off" autoCorrect="off" />

              <svg className="search" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" style={{display: activeCity === "" ? 'block' : 'none'}}>
                <path d="M19.862 18.812l-5.039-5.04a.464.464 0 0 0-.332-.136h-.402A8.123 8.123 0 0 0 8.124 0 8.123 8.123 0 0 0 0 8.125a8.123 8.123 0 0 0 13.636 5.968v.398c0 .125.05.243.137.332l5.039 5.04a.47.47 0 0 0 .664 0l.386-.387a.47.47 0 0 0 0-.664zM8.125 14.999A6.87 6.87 0 0 1 1.25 8.125 6.87 6.87 0 0 1 8.125 1.25a6.87 6.87 0 0 1 6.874 6.875 6.87 6.87 0 0 1-6.874 6.874z" fill="#8E8E8E" fillRule="nonzero"/>
              </svg>

              <svg className="close-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{display: activeCity !== "" ? 'block' : 'none'}} onClick={this.onCloseClicked}>
                <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"/>
              </svg>
            </div>

            <div className={`builder-search-results ${activeCity !== "" ? 'active' : ''}`} style={{display:searchIsOpen ? "block" : "none"}}>
              { this.search(searchInputValue) }
            </div>

            <div className={`duration-wrapper ${activeCity !== "" && getCyoaName() !== 'usa' ? 'active' : ''}`} style={{display:activeCity !== "" && searchIsOpen && getCyoaName() !== 'usa' ? "block" : "none"}}>
                <p className="subtitle">Travel duration</p>

                <div className="row">

                  <div className="columns small-6">
                      <p className="no-margin">
                        Select to adjust duration and stops
                      </p>
                  </div>

                  <div className="columns small-6">

                    <p className="no-margin days-stops-text">
                      <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" className="days-svg">
                        <g fill="none" fillRule="evenodd">
                          <path d="M11.7 10.4H9.85a.52.52 0 0 1-.52-.52V8.02a.52.52 0 0 1 1.04 0v1.34h1.35a.52.52 0 1 1 0 1.04" fill="#F60"/>
                          <g transform="translate(0 -.24)">
                            <path d="M9.85 1.33a8.81 8.81 0 0 0-8.81 8.8 8.81 8.81 0 0 0 17.63 0c0-4.86-3.96-8.8-8.82-8.8m0 18.62A9.85 9.85 0 0 1 0 10.12a9.85 9.85 0 0 1 19.7 0 9.85 9.85 0 0 1-9.85 9.83" fill="#F60" mask="url(#b)"/>
                          </g>
                          <path d="M9.85 2.95A6.95 6.95 0 0 0 2.9 9.88a6.95 6.95 0 0 0 13.9 0 6.95 6.95 0 0 0-6.95-6.93m0 14.9a7.98 7.98 0 0 1-7.98-7.97 7.98 7.98 0 0 1 15.97 0c0 4.39-3.58 7.96-7.99 7.96" fill="#F60"/>
                          <path d="M9.72 4.83a.52.52 0 0 1-.52-.51V2.46a.52.52 0 0 1 1.04 0v1.86c0 .28-.24.51-.52.51M4.28 10.26H2.4a.52.52 0 1 1 0-1.03h1.87a.52.52 0 1 1 0 1.03M9.72 17.55a.52.52 0 0 1-.52-.52v-1.86a.52.52 0 0 1 1.04 0v1.86c0 .29-.24.52-.52.52M17.02 10.26h-1.86a.52.52 0 1 1 0-1.03h1.86a.52.52 0 1 1 0 1.03" fill="#F60"/>
                        </g>
                      </svg>

                      <span>{daySliderText} days</span>

                      <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" className="coach-svg">
                        <g fill="#F60" fillRule="nonzero">
                          <path d="M9.5 16.2a43 43 0 0 1-5.2-.3c-1-.1-1.6-.9-1.6-1.8v-10C2.7 2 4.6 0 6.9 0H12c2.3 0 4.2 1.9 4.2 4.2v10c0 .8-.7 1.6-1.6 1.7a43 43 0 0 1-5.1.3zM6.9 1a3.2 3.2 0 0 0-3.2 3.2v10c0 .3.3.7.7.7a42 42 0 0 0 10.1 0c.4 0 .7-.4.7-.8v-10C15.2 2.5 13.8 1 12 1H7z"/>
                          <path d="M3.2 3.6c-.3 0-.5-.2-.5-.4 0-.3.2-.5.5-.5h12.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5H3.2zM15.7 9.9H3.2c-.3 0-.5-.2-.5-.5 0-.2.2-.4.5-.4h12.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5zM6.8 18h-1c-.7 0-1.3-.5-1.3-1v-1.3c0-.1 0-.2.2-.3l.3-.1 2.6.2c.3 0 .5.2.5.4v1c0 .6-.6 1.1-1.3 1.1zm-1.3-1.8v.7c0 .2.2.3.3.3h1c.1 0 .3-.1.3-.3v-.6l-1.6-.1zM13 18h-.9c-.7 0-1.3-.6-1.3-1.4v-1.4c0-.2.2-.5.5-.5l2.5-.3.4.1.2.4v1.7c0 .8-.6 1.4-1.3 1.4zm-1.2-2.3v.9c0 .2.2.3.3.3h1c.1 0 .3-.1.3-.3v-1l-1.6.1zM11.2 11.7H7.7c-.3 0-.5-.2-.5-.4 0-.3.2-.5.5-.5h3.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5zM11.2 13.5H7.7c-.3 0-.5-.2-.5-.4 0-.3.2-.5.5-.5h3.5c.3 0 .5.2.5.5 0 .2-.2.4-.5.4zM11.2 2.7H7.7c-.3 0-.5-.2-.5-.5 0-.2.2-.4.5-.4h3.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5z"/>
                          <path d="M17.5 5.4a.5.5 0 0 1-.5-.5 1 1 0 0 0-.4-.8c-.7-.5-1.6-.4-1.6-.4a.5.5 0 0 1-.6-.4c0-.3.2-.5.4-.6.1 0 1.4-.2 2.4.6.5.4.8 1 .8 1.6 0 .3-.2.5-.5.5z"/>
                          <path d="M17.6 8.1h-.5c-.5 0-.9-.6-.9-1.3V5c0-.3.2-.5.4-.5h1c.2 0 .4.2.4.5v2.6c0 .3-.2.5-.4.5zM17 5.6v1.2l.1.2h.1V5.6H17zM.5 5.4a.5.5 0 0 1-.5-.5c0-.6.3-1.2.8-1.6 1-.8 2.3-.6 2.4-.6.2 0 .4.3.4.6s-.3.5-.6.5c0 0-1-.2-1.6.3A1 1 0 0 0 1 5c0 .3-.2.5-.5.5z"/>
                          <path d="M.9 8.1H.4c-.2 0-.4-.2-.4-.5V5c0-.3.2-.5.4-.5h1c.2 0 .4.2.4.5v1.8c0 .7-.4 1.3-1 1.3zm-.1-1l.2-.3V5.6H.8V7zM5 13.5H3.2c-.3 0-.5-.2-.5-.5v-1.7c0-.3.2-.5.5-.5H5c.7 0 1.3.5 1.3 1v.6c0 .6-.6 1.1-1.3 1.1zm-1.2-1h1.4v-.6c0-.1 0-.2-.2-.2H3.8v.9zM15.7 13.5h-1.8c-.7 0-1.3-.5-1.3-1v-.6c0-.6.6-1.1 1.3-1.1h1.8c.3 0 .5.2.5.5V13c0 .2 0 .3-.2.4l-.3.1zm-1.8-1.8c-.1 0-.2 0-.2.2v.5c0 .1 0 .2.2.2H15v-.9H14zM12.2 8.1a.5.5 0 1 1 0-1h1.1V5.8a.5.5 0 0 1 1.1 0v1.7c0 .2-.2.5-.5.5h-1.7z"/>
                        </g>
                      </svg>


                      <span>{stopSliderText} stops</span>
                    </p>


                  </div>

                  <div className="columns small-12 margin-t-20">
                    <Slider
                        min={stopSliderMin}
                        max={stopSliderMax}
                        value={stopSliderValue}
                        tooltip={false}
                        onChange={this.handleStopChange}
                      />
                  </div>
                </div>



                {/*<div className="columns small-12 hide">
                <p>
                    <span className="bold uppercase">Duration </span>
                    <span>{daySliderText} days</span>
                  </p>
                  <Slider
                      min={daySliderMin}
                      max={daySliderMax}
                      value={daySliderValue}
                      tooltip={false}
                      onChange={this.handleDayChange}
                    />
                </div>
                */}

                <button type="button" className="busabout--cta orange" onClick={this.refreshClicked} disabled={daySliderText !== 0 && stopSliderText !== 0 ? false : true}>
                  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.613 0h-.323a.387.387 0 0 0-.387.387v3.569A8 8 0 0 0 .01 7.596C0 7.817.177 8 .397 8H.72c.205 0 .376-.16.386-.364a6.903 6.903 0 0 1 13.032-2.797h-3.686a.387.387 0 0 0-.387.387v.322c0 .214.173.387.387.387h5.16A.387.387 0 0 0 16 5.548V.388A.387.387 0 0 0 15.613 0zm-.01 8h-.323a.386.386 0 0 0-.386.364A6.902 6.902 0 0 1 8 14.904a6.906 6.906 0 0 1-6.139-3.743h3.687a.387.387 0 0 0 .387-.387v-.322a.387.387 0 0 0-.387-.387H.388a.387.387 0 0 0-.388.387v5.16c0 .215.173.388.387.388H.71a.387.387 0 0 0 .387-.387v-3.569a8 8 0 0 0 14.893-3.64.386.386 0 0 0-.387-.404z" fill="#FFF" fillRule="nonzero"/>
                  </svg>
                  Update Results
                </button>

            </div>

          </div>




        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return{
    currencyInfo:state.currency,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchSequences
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdatesPanel);



// WEBPACK FOOTER //
// ./src/components/discover/components/updates-panel.js